import React, { createContext } from 'react';

const EditorStateContext = createContext({ });

export const withEditorState = Comp => (props) => {
    const { readOnly } = props;

    if (readOnly) {
        return <Comp {...props} />;
    }

    return (
        <EditorStateContext.Consumer>
            {contextProps => <Comp {...props} {...contextProps} />}
        </EditorStateContext.Consumer>
    );
};

export const EditorStateProvider = ({ value, readOnly, children }) => {
    if (readOnly) {
        return children;
    }

    return <EditorStateContext.Provider value={value}>{children}</EditorStateContext.Provider>;
};
